import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVerticalAlignmentLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"vertical-alignment-left"} maskId="square-filled-radius-0-stroke-1-IconVerticalAlignmentLeft"><path d="M4 3H3V21H4V3Z" fill="currentColor"/><path d="M6 6V11H21V6H6Z" fill="currentColor"/><path d="M6 13V18H17V13H6Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconVerticalAlignmentLeft;
